import { Row, Col, Card, Typography, Button, Badge } from 'antd';

const { Title, Paragraph } = Typography;

export function Pricing() {
  const plans = [
    { name: 'Starter', price: '$49', desc: 'For startups', popular: false },
    { name: 'Growth', price: '$199', desc: 'For scaling SaaS', popular: true },
    {
      name: 'Business',
      price: '$499',
      desc: 'For established companies',
      popular: false,
    },
    {
      name: 'Enterprise',
      price: 'Custom',
      desc: 'Custom infrastructure',
      popular: false,
    },
  ];

  return (
    <section
      id="pricing"
      style={{ padding: '80px 24px', backgroundColor: '#ffffff' }}
    >
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '64px' }}>
          <Title
            level={2}
            style={{
              fontSize: 'clamp(24px, 3.5vw, 36px)',
              color: '#1f1f1f',
              margin: 0,
              fontWeight: 700,
            }}
          >
            Scale As You Grow
          </Title>
        </div>

        <Row gutter={[24, 24]}>
          {plans.map((plan) => {
            const cardContent = (
              <Card
                variant="outlined"
                hoverable
                className={plan.popular ? 'popular-pricing-card' : ''}
                style={{
                  height: '100%',
                  borderRadius: '12px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
                styles={{
                  body: {
                    padding: '32px 24px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    flexGrow: 1,
                    height: '100%',
                  },
                }}
              >
                <div>
                  <Title
                    level={3}
                    style={{
                      fontSize: '22px',
                      margin: '0 0 8px 0',
                      color: '#1f1f1f',
                      fontWeight: 600,
                    }}
                  >
                    {plan.name}
                  </Title>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'baseline',
                      marginBottom: '16px',
                    }}
                  >
                    <span
                      style={{
                        fontSize: '40px',
                        fontWeight: 'bold',
                        color: '#1f1f1f',
                      }}
                    >
                      {plan.price}
                    </span>
                    {plan.price !== 'Custom' && (
                      <span
                        style={{
                          color: '#8c8c8c',
                          marginLeft: '4px',
                          fontSize: '14px',
                        }}
                      >
                        /mo
                      </span>
                    )}
                  </div>
                  <Paragraph
                    type="secondary"
                    style={{
                      fontSize: '14px',
                      marginBottom: '24px',
                      minHeight: '40px',
                    }}
                  >
                    {plan.desc}
                  </Paragraph>
                </div>
                <Button
                  type={plan.popular ? 'primary' : 'default'}
                  size="large"
                  block
                  href="/login"
                  style={{
                    height: '44px',
                    fontWeight: 600,
                  }}
                >
                  Get Started
                </Button>
              </Card>
            );

            return (
              <Col xs={24} sm={12} md={6} key={plan.name}>
                {plan.popular ? (
                  <Badge.Ribbon
                    text="Most Popular"
                    color="blue"
                    style={{ transform: 'translate(4px, -4px)' }}
                  >
                    {cardContent}
                  </Badge.Ribbon>
                ) : (
                  cardContent
                )}
              </Col>
            );
          })}
        </Row>
      </div>
    </section>
  );
}
